import { Button } from '@playbooks/ui/components/button';
import { cn } from '@playbooks/ui/lib/utils';
import { capitalize } from '@playbooks/utils';

const ViewSubnav = ({ view = '', options = [], setView, className = '' }) => {
	// Theme
	const rootClassName = cn('flex-start gap-2 overflow-x-scroll custom-scrollbar', className);

	// Render
	return (
		<div className={rootClassName}>
			{options.map((option, i) => (
				<span key={i}>
					<Button variant='tab' data-active={option === view} onClick={() => setView(option)} className='w-full p-3'>
						{capitalize(option ? option : 'all')}
					</Button>
				</span>
			))}
		</div>
	);
};
export { ViewSubnav };
